<template>
<span>
    <span v-if="wide">Data </span>Sources: 
    <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/situation-reports">WHO</a>, 
    <a href="https://www.cdc.gov/coronavirus/2019-ncov/index.html">CDC</a>, 
    <a href="https://www.ecdc.europa.eu/en/geographical-distribution-2019-ncov-cases">ECDC</a>, 
    <a href="http://www.nhc.gov.cn/xcs/yqtb/list_gzbd.shtml">NHC</a>, 
    <a href="https://3g.dxy.cn/newh5/view/pneumonia?scene=2&clicktime=1579582238&enterid=1579582238&from=singlemessage&isappinstalled=0">DXY</a>, 
    <a href="https://systems.jhu.edu/">JHU</a>, 
    <a href="https://www.realclearpolitics.com/">RCP</a> 
    <span v-if="wide">| Population: </span>
    <a v-if="wide && type == 'global'" href="https://data.worldbank.org/indicator/SP.POP.TOTL">World Bank</a> 
    <a v-if="wide && type == 'usa'" href="https://www.census.gov/newsroom/press-kits/2019/national-state-estimates.html">U.S. Census</a> 
    <!--| Seasonal Flu <sup>1</sup>: 
    <span v-if="type == 'usa'">
        <a href="https://wonder.cdc.gov/mcd.html">CDC 2008–2018 10-Year Avg</a>
    </span>
    <span v-if="type == 'global'">
        <a href="https://www.cdc.gov/">CDC</a>/<a href="https://www.who.int/news-room/detail/14-12-2017-up-to-650-000-people-die-of-respiratory-diseases-linked-to-seasonal-flu-each-year">WHO 2017 Estimates</a>
    </span>-->
</span>
</template>

<script>
export default {
    name: 'covid-info',
    props: {
        wide: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'global',
        },
    },
}
</script>